import {useMemo} from 'react';
import { formatInvoiceSubject } from '../../../utils/invoiceUtils';
import { useLocation } from 'react-router-dom';

function InitialInfoStep({ formData, ...rest }) {
    const location = useLocation();
    const mode = useMemo(() => {
            if (location.pathname.includes('/view/')) return 'view';
            if (location.pathname.includes('/edit/')) return 'edit';
            return 'create';
        }, [location.pathname]);
    return (
        <div className="step-content">
            <h5 className="mb-4">اطلاعات اولیه صورتحساب</h5>
            <div className="row">
                <div className="col-md-6 mb-3">
                    <label className="form-label text-muted">وضعیت صورتحساب:</label>
                    <p className="fw-bold text-primary">{mode === 'create' ? 'در حال صدور' : mode == 'view' ? 'مشاهده صورتحساب' : 'صادر شده (در حال ویرایش)'}</p>
                </div>
                <div className="col-md-6 mb-3">
                    <label className="form-label text-muted">موضوع صورتحساب:</label>
                    <p className="fw-bold text-primary">{formatInvoiceSubject(formData.invoiceSubject)}</p>
                </div>
            </div>
        </div>
    );
}

export default InitialInfoStep;